"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocaleDayjs = exports.getFlagCode = exports.getCurrentLng = void 0;
const i18next_1 = __importDefault(require("i18next"));
const env_1 = require("../env");
const getCurrentLng = () => {
    var _a;
    let lng = i18next_1.default.language || '';
    if (!env_1.isReactNative &&
        !lng &&
        typeof window !== 'undefined' &&
        ((_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.i18nextLng)) {
        lng = window.localStorage.i18nextLng;
    }
    // eslint-disable-next-line prefer-destructuring
    lng = (lng || '').split('-')[0]; // to convert en-US, ru-RU to our format: en, ru
    return lng;
};
exports.getCurrentLng = getCurrentLng;
const getFlagCode = (code) => {
    switch (code) {
        case 'en':
            return 'GB';
        case 'ZH':
        case 'zh':
            return 'CN';
        default:
            return code.toUpperCase();
    }
};
exports.getFlagCode = getFlagCode;
// https://unpkg.com/dayjs/locale.json
const getLocaleDayjs = () => {
    const code = (0, exports.getCurrentLng)();
    switch (code) {
        case 'kz':
            return 'kk';
        case 'uz':
            return 'uz-latn';
        case 'cn':
            return 'zh';
        default:
            return code;
    }
};
exports.getLocaleDayjs = getLocaleDayjs;
//# sourceMappingURL=index.js.map